import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN, INDEX_MAIN_PAGE_PATH, OAUTH2_LOGIN_PAGE_PATH } from '@/store/mutation-types'
import { generateIndexRouter, isOAuth2AppEnv, getMenuRoutes } from '@/utils/util'
import { constantRouterMap } from '@/config/router.config'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/user/register', '/user/register-result', '/user/alteration'] // no redirect whitelist
whiteList.push(OAUTH2_LOGIN_PAGE_PATH)
const constRoutes = getMenuRoutes(constantRouterMap)
const constRoutePaths = constRoutes.map(r => r.path)
whiteList.push(...constRoutePaths)

router.beforeEach(async (to, from, next) => {
  NProgress.start() // start progress bar

  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login' || to.path === OAUTH2_LOGIN_PAGE_PATH) {
      next({ path: INDEX_MAIN_PAGE_PATH })
      NProgress.done()
    } else {
      const permissionList = store.getters.permissionList
      if (store.getters.permissionList.length === 0) {
        store.dispatch('InitWorkbench')
        const permissionData = await store.dispatch('GetPermissionList')

        if (permissionData) {
          const menuData = permissionData.result.menu
          //console.log(res.message)
          if (menuData === null || menuData === '' || menuData === undefined) {
            return
          }
          let constRoutes = []
          constRoutes = generateIndexRouter(menuData)

          // 添加主界面路由
          await store.dispatch('UpdateAppRouter', { constRoutes })

          // 根据roles权限生成可访问的路由表
          // 动态添加可访问路由表

          const add = store.getters.addRouters

          router.addRoutes(store.getters.addRouters)
          const redirect = decodeURIComponent(from.query.redirect || to.path)
          if (to.path === redirect) {
            // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            next({ ...to, replace: true })
          } else {
            // 跳转到目的路由
            next({ path: redirect })
          }
        } else {
          store.dispatch('Logout').then(() => {
            next({ path: '/user/login', query: { redirect: to.fullPath } })
          })
        }
        // .catch(() => {

        //   store.dispatch('Logout').then(() => {

        //     next({ path: '/user/login', query: { redirect: to.fullPath } })
        //   })
        // })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，如果进入的页面是login页面并且当前是OAuth2app环境，就进入OAuth2登录页面
      if (to.path === '/user/login' && isOAuth2AppEnv()) {
        next({ path: OAUTH2_LOGIN_PAGE_PATH })
      } else {
        // 在免登录白名单，直接进入
        next()
      }
      NProgress.done()
    } else {
      // 如果当前是在OAuth2APP环境，就跳转到OAuth2登录页面
      let path = isOAuth2AppEnv() ? OAUTH2_LOGIN_PAGE_PATH : '/user/login'
      next({ path: path, query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
